import React from 'react';
import { Button } from 'antd';
import CommonListsIndex from '../../components/CommonLists/index';
import AlbumList from './list';

class Album extends CommonListsIndex {
  constructor() {
    super();
    this.api = 'album';
    this.addComponent = ``;
    this.editComponent = ``;
    this.listsComponent = AlbumList;
    this.model_width = '90%';
  }
  componentDidMount() {
    this.queryList({ type: this.props.match.params.type });
    this.addComponent = `/content/${this.api}/${
      this.props.match.params.type
    }/add`;
    this.editComponent = `/content/${this.api}/${
      this.props.match.params.type
    }/id/edit`;
  }

  componentWillReceiveProps(nexrProps) {
    // 切换路由 type改变
    if (nexrProps.match.params.type !== this.props.match.params.type) {
      this.queryList({ type: nexrProps.match.params.type });
      this.addComponent = `/content/${this.api}/${
        nexrProps.match.params.type
      }/add`;
      this.editComponent = `/content/${this.api}/${
        nexrProps.match.params.type
      }/id/edit`;
    }
  }

  freshQueryList = () => {
    this.queryList({ type: this.props.match.params.type });
  };

  render() {
    const ListsComponent = this.listsComponent;
    return (
      <div>
        <div className="tantuer-op">
          <Button type="primary" icon="plus" onClick={this.add}>
            新增
          </Button>
        </div>

        <ListsComponent
          data={this.state.listsData}
          edit={this.edit}
          queryList={this.freshQueryList}
        />
      </div>
    );
  }
}
export default Album;
